import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col overflow-y-hidden gap-2" }
const _hoisted_2 = { class: "w-full h-[41px] px-2 rounded-primary-radius bg-[#E5E4E2] grid grid-cols-3 gap-3 lg:gap-0 items-center" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col h-[calc(100%-41px)] overflow-y-auto w-full min-w-[500px] xl:min-w-[900px]"
}
const _hoisted_10 = { class: "w-full h-full overflow-y-auto flex flex-col gap-2" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "text-primary-text-color text-sm font-normal leading-[20px] underline cursor-pointer" }
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = { class: "text-primary-text-color text-sm font-normal leading-[20px] break-all" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "text-primary-text-color text-sm font-normal leading-[20px]" }
const _hoisted_17 = {
  key: 1,
  class: "w-full flex items-center justify-center mt-10 text-primary-text-color text-base"
}

import { useTranslate } from "@/composables/useTranslate";
import { Worker } from "@/types";


type Props = {
  workers: Worker[];
};

export default /*@__PURE__*/_defineComponent({
  __name: 'InstallersTable',
  props: {
    workers: {}
  },
  setup(__props: any) {

const { t } = useTranslate();



return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("installers.table_column_name")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("installers.table_column_email")), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("installers.table_column_role")), 1)
      ])
    ]),
    (__props.workers && __props.workers.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workers, (worker) => {
              return (_openBlock(), _createBlock(_component_RouterLink, {
                to: `/installers/${worker.id}`,
                key: worker.id,
                class: "w-full min-h-[41px] rounded-primary-radius px-2 bg-white grid grid-cols-3 gap-3 lg:gap-0 items-center"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(worker.fullname ? worker.fullname : "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(worker.email ? worker.email : "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(worker.role ? worker.role : "-"), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(t)("installers.no_results_found")), 1))
  ]))
}
}

})